import { render, staticRenderFns } from "./DetailedView.vue?vue&type=template&id=1a1ae93c&scoped=true"
import script from "./DetailedView.vue?vue&type=script&lang=js"
export * from "./DetailedView.vue?vue&type=script&lang=js"
import style0 from "./DetailedView.vue?vue&type=style&index=0&id=1a1ae93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ae93c",
  null
  
)

export default component.exports